// Per-printing display titles. Thin wrappers over the art-group axis in
// artGroups.js, for surfaces that hold a printing (or only a resolved image
// URL) rather than a group id.

import { artGroupOf, artGroupDisplayName } from './artGroups';

// Display name for a specific printing: the printed alt-art title when the
// art carries one, else the card's real name. `printing` may be a printing
// object or a bare slug string.
export function printingDisplayName(card, printing) {
  return artGroupDisplayName(card, artGroupOf(printing));
}

// Same, from a card image URL (`.../<slug>.webp` or `<slug>.v<N>.webp`)
// for surfaces that carry only the resolved image, like CardInspector.
export function printingDisplayNameFromImageUrl(card, imageUrl) {
  const m = /\/([a-z0-9_-]+?)(?:\.v\d+)?\.webp/.exec(String(imageUrl || ''));
  return m ? printingDisplayName(card, m[1]) : (card?.name || '');
}
